module.exports = __webpack_public_path__ + "img/1.9cf85307.png";